module.exports = __webpack_public_path__ + "static/media/poster-covid.d8673133.png";